<template>
  <RouterView :key="key" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useExplorerStore } from '@/features/explorer/store'
import { useRoute } from 'vue-router'
import {
  GuidanceActionState,
  GuidanceId,
} from '@/shared/graphql/legacy/generated'
import { useUserStore } from '@/shared/stores/user'
import { useModalHost, useSheetHost } from '@dacr/library'
import { openModal, Modals } from '@/shared/dialogs/modals'
import AddRegistrationTipImage from '@/assets/images/add-registration-tip.png'
import { preloadImage } from '@/shared/utils/image'

const route = useRoute()
const explorerStore = useExplorerStore()
const userStore = useUserStore()
const { isOpen: modalIsOpen } = useModalHost()
const { isOpen: sheetIsOpen } = useSheetHost()
const isOpen = computed(() => modalIsOpen.value || sheetIsOpen.value)

const key = computed(() => route.path + explorerStore.currentFolder?.name)

const tipToShow = computed(() =>
  userStore.user?.guidanceStates.states.find(
    (state) => state.state.state === GuidanceActionState.Show
  )
)

const showTip = () => {
  return !isOpen.value && route.path.includes('home')
}

watch(
  tipToShow,
  () => {
    if (!showTip()) return

    if (tipToShow.value?.id === GuidanceId.WelcomeModal) {
      const tipImageReady = preloadImage(AddRegistrationTipImage)

      setTimeout(async () => {
        if (!showTip()) return

        await tipImageReady

        if (!showTip()) return

        openModal(Modals.UploadTip)
      }, 3000)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)
</script>
